// extracted by mini-css-extract-plugin
export default {"slider":"ScalarToolbar_slider__nt1PH","thumb":"ScalarToolbar_thumb__WDGZR","track":"ScalarToolbar_track__83NfZ","rail":"ScalarToolbar_rail__d9R-G"};